import React from 'react';

interface Props {
  children: React.ReactNode;
}

const ShareSlideOverInfoContainer = ({ children }: Props) => {
  return (
    <div className='w-full items-center justify-center '>
      <div className='flex flex-col items-center justify-center rounded-lg space-y-5 m-auto bg-bedrock-light-gray p-4'>
        {children}
      </div>
    </div>
  );
};

export default ShareSlideOverInfoContainer;
